import React from 'react'
import Style from'./DriverDetail.module.css'
import moment from 'moment-jalaali'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEarth } from '@fortawesome/free-solid-svg-icons'
const DriverDetail = ({info}) => {
        const OpenMapHandler = () => {
    window.open(
      `https://maps.apple.com/?q=${info.driver_lon},${info.driver_lat}`
    );
  };
  return (
    <fieldset className={Style.fieldSetHolder}>
    <legend>اطلاعت پیک</legend>
    <div>
        <strong >نام پیک:</strong>
        <span>{info?.driver_name}</span>
    </div>
    <div>
        <strong >شماره پیک:</strong>
        <span>{info?.driver_phone}</span>
    </div>
    <div>
        <strong >شناسه پیک:</strong>
        <span>{info?.deliver_id}</span>
    </div>
        <div>
        <strong >وسیله نقلیه :</strong>
        <span>{info?.vehicle_type} {info?.vehicle_model} {info?.vehicle_color} {info?.vehicle_plate}</span>
    </div>
        <div>
            <strong>آخرین موقعیت پیک: </strong>
            <span className={Style.locationHolder} onClick={OpenMapHandler}>کلیک کنید<FontAwesomeIcon icon={faEarth}/></span>
        </div>
  </fieldset>
  )
}

export default DriverDetail